import React from "react";

interface SideDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  width?: string | number;
  children: React.ReactNode;
  title?: string;
  actionButton?: React.ReactNode;
  branding?: {
    primaryColor?: string;
    secondaryColor?: string;
    gradientEnabled?: boolean;
  };
}

export const SideDrawer = ({
  isOpen,
  onClose,
  width = "50vw",
  children,
  title,
  actionButton,
  branding,
}: SideDrawerProps) => {
  if (!isOpen) {
    return null;
  }

  const primaryColor = branding?.primaryColor || '#4E9CFF';

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/30 z-40 transition-opacity duration-300"
        onClick={onClose}
        aria-hidden="true"
        style={{ opacity: 1, pointerEvents: "auto" }}
      />
      {/* Drawer */}
      <aside
        className="fixed top-0 right-0 h-full z-50 bg-white shadow-xl transition-transform duration-300 ease-in-out flex flex-col w-screen sm:w-[calc(var(--drawer-width,50vw))]"
        style={{
          '--drawer-width': width,
          maxWidth: "100vw",
          transform: "translateX(0)",
        } as React.CSSProperties & { '--drawer-width': string | number }}
        role="dialog"
        aria-modal="true"
      >
        <div 
          className="flex flex-col sm:flex-row sm:items-center justify-between px-6 py-4 min-h-16 sm:h-16 border-b-4"
          style={{ borderBottomColor: primaryColor }}
        >
          <div className="flex items-center justify-between sm:justify-start sm:flex-1">
            {title && <h2 className="text-lg font-semibold text-gray-800">{title}</h2>}
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl leading-none sm:hidden"
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className="flex items-center space-x-4 mt-3 sm:mt-0">
            {actionButton}
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 text-2xl leading-none hidden sm:block"
              aria-label="Close"
            >
              &times;
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 min-h-0">{children}</div>
      </aside>
    </>
  );
};
